import NewActivityCard from '@alltrails/shared/components/ActivityCard';
import MapCard from '@alltrails/shared/components/MapCard';
import useLanguageRegionCode from 'hooks/useLanguageRegionCode';
import { Context } from '@alltrails/shared/types/context';
import Track from '@alltrails/shared/types/track';
import useActivityDuration from 'hooks/useActivityDuration';
import { getActivityFromTrack, getMapFromTrack } from 'utils/cardInfo';

type ActivityCardProps = {
  track: Track;
  context: Context;
  forceFirstParty?: boolean;
  handleCardClick: () => void;
  handleFavoriteClick: () => void;
  isFavorite?: boolean;
  messagingChannel?: {
    publish: (event: string, track: Track) => void;
  };
  allowItemMoving?: boolean;
  dragHandleProps?: { [key: string]: any };
  allowItemDelete?: boolean;
  handleItemDeleteClick?: () => void;
  itemDeleteLabel?: string;
  useV3api?: boolean;
};

const ActivityCard = ({
  track,
  context,
  forceFirstParty,
  handleCardClick,
  handleFavoriteClick,
  isFavorite,
  messagingChannel,
  allowItemMoving,
  dragHandleProps,
  allowItemDelete,
  handleItemDeleteClick,
  itemDeleteLabel,
  useV3api
}: ActivityCardProps): JSX.Element => {
  const languageRegionCode = useLanguageRegionCode();
  const minutes = useActivityDuration(track);
  const deleteButton =
    allowItemDelete && handleItemDeleteClick && itemDeleteLabel
      ? {
          title: itemDeleteLabel,
          onClick: handleItemDeleteClick
        }
      : undefined;
  const isFirstParty = forceFirstParty || context?.currentUser?.id === track.user?.id;

  if (track.type === 'map') {
    return (
      <MapCard
        languageRegionCode={languageRegionCode}
        onCardClick={handleCardClick}
        onCardMouseEnter={() => messagingChannel?.publish?.('item.mouseenter', track)}
        onCardMouseLeave={() => messagingChannel?.publish?.('item.mouseleave', track)}
        onFavoriteClick={handleFavoriteClick}
        isFavorite={isFavorite}
        variant="standard"
        map={getMapFromTrack(track, minutes, languageRegionCode)}
        isFirstParty={isFirstParty}
        useMetric={context?.displayMetric}
        dragHandleProps={allowItemMoving ? dragHandleProps : undefined}
        deleteButton={deleteButton}
        useV3api={useV3api}
      />
    );
  }

  return (
    <NewActivityCard
      languageRegionCode={languageRegionCode}
      onCardClick={handleCardClick}
      onCardMouseEnter={() => messagingChannel?.publish?.('item.mouseenter', track)}
      onCardMouseLeave={() => messagingChannel?.publish?.('item.mouseleave', track)}
      onFavoriteClick={handleFavoriteClick}
      isFavorite={isFavorite}
      variant="standard"
      activity={getActivityFromTrack(track, minutes)}
      isFirstParty={isFirstParty}
      useMetric={context?.displayMetric}
      dragHandleProps={allowItemMoving ? dragHandleProps : undefined}
      deleteButton={deleteButton}
      useV3api={useV3api}
    />
  );
};

export default ActivityCard;
